<main [ngClass]="{'difuminar_Fondo' : !loadingSummary}">
  <section class="summary-section">
    <section class="basic-info">
      <h3 style="display: inline-block;"> {{cesionarioSummaryDetail?.cesionarioName || '-'}}
        <span>&nbsp; &nbsp; &nbsp; &nbsp;
          {{cesionarioSummaryDetail?.cesionarioRut || '-'}}
        </span>
      </h3>
      <h3>{{cesionarioSummaryDetail?.currentActivity || 'No presenta actividad'}}</h3>
    </section>
    <article class="article__icons">
      <section class="section__title__icons">
        <div class="section__icons">
          Conectado
          <i-tabler [ngStyle]="{
                  color: !cesionarioDebt ? 'grey' : cesionarioDebt.isSiiConnected ? 'mediumspringgreen' :'red'
                  }" class="icon-20" name="circle-filled"></i-tabler>
        </div>
        <div (click)="formTGR()" class="section__icons" style="cursor: pointer;">
          TGR
          <div>
            <i-tabler [ngStyle]="{
                  color: 
                  cesionarioDebt?.getTgr === 2
                    ? 'red'
                    : cesionarioDebt?.getTgr === 1
                    ? 'mediumspringgreen'
                    : 'grey'
                  }" class="icon-20" name="circle-filled"></i-tabler>
          </div>
        </div>
        <div (click)="formDicom()" class="section__icons" style="cursor: pointer;">
          DICOM
          <div>
            <i-tabler *ngIf="hasDicomHistorial" title="Monto Deuda: {{dicomDebt | currency :'CLP'}}" [ngStyle]="{
                  color:
                      cesionarioDebt?.getDicom === 2
                      ? 'red'
                      : cesionarioDebt?.getDicom === 1
                      ? 'mediumspringgreen'
                      : 'grey'
                  }" class="icon-20" name="circle-filled"></i-tabler>
            <i-tabler *ngIf="!hasDicomHistorial" title="Monto Deuda: {{dicomDebt | currency :'CLP'}}"
              [ngStyle]="{color: 'grey'}" class="icon-20" name="circle-filled"></i-tabler>
          </div>
        </div>
        <div (click)="formCMF()" class="section__icons" style="cursor: pointer;">
          CMF
          <div>
            <i-tabler [ngStyle]="{
                  color: !cesionarioDebt ? 'grey': cesionarioDebt.getCmf === 2 ? 'red' : 'mediumspringgreen'
                }" class="icon-20" name="circle-filled"></i-tabler>
          </div>
        </div>
        <div (click)="refreshFogape()" class="section__icons" style="cursor: pointer;">
          Fogape
          <div *ngIf="!loadingFogape; else spinner">
            <i-tabler [ngStyle]="{
                  color: 
                  fogapeCesionario?.hasFogape === false
                    ? 'red'
                    : fogapeCesionario?.hasFogape === true
                    ? 'mediumspringgreen'
                    : 'grey'
                }" class="icon-20" name="circle-filled"></i-tabler>
          </div>
        </div>

      </section>
    </article>
  </section>
  <section>
    <app-filters-files-clients (changeClientFileFilter)="receiveChangeFilters($event)">
    </app-filters-files-clients>
  </section>

  <section class="container-kpis">
    <div class="card-kpi cardWithShadow">
      <div class="kpi-detail">
        <h4>Fact Recibidas</h4>
        <h3>{{ (cesionarioSummaryDetail?.totalAmountReceivedInvoices | currency: 'CLP') || 0 }}</h3>
      </div>

      <div class="kpi-detail">
        <h4>Docs</h4>
        <h3>{{cesionarioSummaryDetail?.receivedInvoices || 0}}</h3>
      </div>
    </div>

    <div class="card-kpi cardWithShadow">
      <div class="kpi-detail">
        <h4>Fact Cedidas</h4>
        <h3>{{ (cesionarioSummaryDetail?.totalAmountTransferInvoices | currency: 'CLP') || 0 }}</h3>
      </div>
      <div class="kpi-detail">
        <h4>Docs</h4>
        <h3>{{cesionarioSummaryDetail?.transferInvoices || 0}}</h3>
      </div>
    </div>
  </section>

  <section>
    <mat-card>
      <mat-tab-group class="m-b-1 swipe-container">
        <mat-tab label="Información">
          <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
            <ng-template matTabContent>
              <app-information [companyId]="cesionarioCompanyId" [fogapeInfo]="fogapeCesionario">
              </app-information>
            </ng-template>
          </div>
        </mat-tab>

        <mat-tab label="Facturas">
          <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
            <ng-template matTabContent>
              <mat-tab-group mat-stretch-tabs>
                <mat-tab label="Recibidas">
                  <ng-template matTabContent>
                    <mat-card class="cardWithShadow">
                      <mat-card-content class="p-24">
                        <ng-container *ngIf="{pagedCesionarios: pagedReceivedInvoices$ | async} as data">
                          <ng-container *ngIf="data.pagedCesionarios as pagedCesionarios; else loading">
                            <app-received-invoices-table [invoices]="pagedCesionarios.results"
                              [totalRows]="pagedCesionarios.totalRows" [page]="receivedInvoiceQuery.page"
                              [pageSize]="receivedInvoiceQuery.size" [sortColumn]="receivedInvoiceQuery.sortColumn"
                              [sortDirection]="receivedInvoiceQuery.sortDirection"
                              (paginationChange)="receiveChangePaginationReceivedInvoices($event)"
                              (sortingChange)="receiveChangeSortReceivedInvoices($event)">
                            </app-received-invoices-table>
                          </ng-container>
                        </ng-container>
                      </mat-card-content>
                    </mat-card>
                  </ng-template>
                </mat-tab>
                <mat-tab label="Cedidas">
                  <ng-template matTabContent>
                    <mat-card class="cardWithShadow">
                      <mat-card-content class="p-24">
                        <ng-container *ngIf="{pagedCedidoInvoices: pagedCedidoInvoices$ | async} as data">
                          <ng-container *ngIf="data.pagedCedidoInvoices as pagedCedidos; else loading">
                            <app-cedido-invoices-table [cedidos]="pagedCedidos.results" [totalRows]="pagedCedidos.totalRows"
                              [page]="cedidoInvoiceQuery.page" [pageSize]="cedidoInvoiceQuery.size"
                              [sortColumn]="cedidoInvoiceQuery.sortColumn"
                              [sortDirection]="cedidoInvoiceQuery.sortDirection"
                              (paginationChange)="receiveChangePaginationCedidoInvoices($event)"
                              (sortingChange)="receiveChangeSortCedidoInvoices($event)">
                            </app-cedido-invoices-table>
                          </ng-container>
                        </ng-container>
                      </mat-card-content>
                    </mat-card>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </ng-template>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card>
  </section>
</main>

<ng-template #loading>
  <div class="spinner-section">
    <mat-spinner diameter="70"></mat-spinner>
  </div>
</ng-template>


<ng-template #spinner>
  <div>
    <mat-spinner diameter="20"></mat-spinner>
  </div>
</ng-template>